export const parseMyCompareItemId = (rawUrl: string, compareSite: string): string => {
    let parsedUrl: URL;
    try {
        parsedUrl = new URL(rawUrl);
    } catch {
        throw new Error("유효한 URL을 입력하세요.");
    }

    if (compareSite === "naver") {
        const isValidHost = parsedUrl.hostname === "cr.shopping.naver.com";
        const isValidPath = parsedUrl.pathname.startsWith("/adcr");
        const nvMid = parsedUrl.searchParams.get("nvMid") || "";

        if (!isValidHost || !isValidPath) {
            throw new Error("유효한 네이버 URL이 아닙니다.");
        }
        if (!nvMid.trim()) {
            throw new Error("네이버 URL에서 nvMid를 찾을 수 없습니다.");
        }
        return nvMid.trim();
    }

    if (compareSite === "danawa") {
        const isValidHost = parsedUrl.hostname === "prod.danawa.com";
        const isValidPath = parsedUrl.pathname === "/bridge/loadingBridge.html";
        const cmpnyc = parsedUrl.searchParams.get("cmpnyc") || "";
        const linkPcode = parsedUrl.searchParams.get("link_pcode") || "";

        if (!isValidHost || !isValidPath) {
            throw new Error("유효한 다나와 URL이 아닙니다.");
        }
        if (!cmpnyc.trim() || !linkPcode.trim()) {
            throw new Error("다나와 URL에서 cmpnyc 또는 link_pcode를 찾을 수 없습니다.");
        }
        return `${cmpnyc.trim()}_${linkPcode.trim()}`;
    }

    if (compareSite === "enuri") {
        const isValidHost = parsedUrl.hostname === "www.enuri.com";
        const isValidPath = parsedUrl.pathname === "/move/Redirect.jsp";
        const plNo = parsedUrl.searchParams.get("pl_no") || "";

        if (!isValidHost || !isValidPath) {
            throw new Error("유효한 에누리 URL이 아닙니다.");
        }
        if (!plNo.trim()) {
            throw new Error("에누리 URL에서 pl_no를 찾을 수 없습니다.");
        }
        return plNo.trim();
    }

    throw new Error("가격비교 사이트를 선택하세요.");
};
